export const REACT_APP_API_BASE_URL = "https://api.fansroom.com";
export const REACT_APP_API_VERSION = "/api/v1";
export const REACT_APP_API_USERTYPE = "/admin";